import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CustomMetricComponent from "../components/1_CustomMetricComponent";

const CustomMetric = () => {
  return (
    <div>
      <MasterLayout>
        <CustomMetricComponent />
      </MasterLayout>
    </div>
  );
};

export default CustomMetric;
